/**
 * Дефолтні налаштування додатку (fallback якщо localStorage порожній)
 */

/**
 * Соцмережі UA-флагману (bibleawr.com).
 * Дочірні сайти (by/am/pl) задають власні через app.config → siteConfig.socials.
 * Використовується у LayoutFooterFooterMain як явний fallback, не інлайн-константа.
 */
export const uaSocialLinks = [
  { name: 'YouTube',   url: 'https://youtube.com/@bibleschool-onlinecourses', image: '/assets/images/footer/youtube.svg' },
  { name: 'Instagram', url: 'https://www.instagram.com/school_bible',          image: '/assets/images/footer/instagram.svg' },
  { name: 'Facebook',  url: 'https://www.facebook.com/probible',               image: '/assets/images/footer/facebook.svg' },
  { name: 'TikTok',    url: 'https://www.tiktok.com/@bible_school_ua',         image: '/assets/images/footer/tiktok.svg' },
] as const
export const defaultSettings = {
  application_lang: 'en',
  application_version: 'v1',
  application_theme: 'light',
} as const

export type AppSettings = {
  application_lang: string
  application_version: string
  application_theme: string
}
